import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import { AppContext } from '../../context/AppContext';
import BakeasyEmptyMsg from '../../components/common/BakeasyEmptyMsg';
import BakeasyHeaderLabel from '../../components/labels/BakeasyHeaderLabel';
import BakeasyTable from '../../components/tables/BakeasyTable';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import * as Button from '../../components/buttons/BakeasyButtons';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import * as TextField from '../../components/textfields/BakeasyTextFields';
import {
  createOrderState,
  fetchcreateOrders,
} from '../../redux_store/slices/createOrdersSlice';
import {
  deleteDraftOrderById,
  draftOrderState,
  draftorders,
  fetchdraftOrders,
} from '../../redux_store/slices/draftOrdersSlice';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import BakeasyPaper from '../../components/common/BakesasyPaper';
import { orderTableHeaders } from '../../constants/TableHeaders';
import BakeasySelectedFilters from '../../components/common/BakeasySelectedFilters';
import { deleteKeyFromObject, preparePayload } from '../../utils/commonUtils';
import { RED_500 } from '../../constants/Colors';
import { useDebouncedFetch } from '../../custom/useDebouncedCallback';

export const Orders: FC = (): ReactElement => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const fetchData = useDebouncedFetch();

  let myContext = React.useContext(AppContext);
  const isMobile = useMediaQuery('(max-width:600px)');
  const [search, setSearch] = useState<string>('');
  const [ordersList, setOrdersList] = useState<any[]>([]);
  const [count, setCount] = React.useState<number>(0);
  const tableRef = React.useRef<any>();

  const [selectedRows, setSelectedRows] = React.useState<any>([]);
  const [quantity, setQuantity] = React.useState<any>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const [tFilter, setTFilter] = React.useState<any>({});

  let { value, rowsPerPage, pageNo, filter } = useAppSelector(createOrderState);
  let _draftOrders: any = useAppSelector(draftOrderState);

  useEffect(() => {
    dispatch(fetchdraftOrders({ page: 1, limit: 5 }));
  }, []);

  function openFilterStoreproductConfirmDialog() {
    myContext.setConfirmDialog({
      type: 'product-order-filter',
      open: true,
      title: t('PRODUCT_FILTER'),
      data: filter,
      onNoClick: (event: any) => {},
      onYesClick: async (event: any, param: any) => {
        setTFilter(param);
        refreshPageData(0, search, param);
      },
    });
  }

  // useEffect(() => {
  //   return () => fetchData.cancel(); // Cancel debounce on component unmount to avoid memory leaks
  // }, [fetchData]);

  const refreshPageData = async (
    newPage: number,
    search?: string,
    filter?: {} | undefined
  ) => {
    let payload = await preparePayload(
      {
        limit: rowsPerPage,
        page: newPage + 1,
        sortBy: 'createdDate',
        sortDirection: -1,
      },
      filter,
      search,
      newPage
    );
    await dispatch(fetchcreateOrders(payload));
    // await fetchData(fetchcreateOrders, payload);
  };

  useEffect(() => {
    if (value?.totalCount === -1) {
      refreshPageData(pageNo);
    } else {
      // const draftData: any = _draftOrders?.value?.data?.[0];
      const draftData = Array.isArray(_draftOrders?.value?.data?.[0]?.products)
        ? _draftOrders?.value?.data?.[0]?.products
        : [];

      const filteredData: any = value?.data?.map((product: any) => {
        const draftProduct = draftData?.find(
          (draftItem: any) => draftItem?.productId === product?.productId
        );

        return {
          _id: product?._id,
          productId: product?.productId,
          userProductId: product?.userProductId,
          productName: product?.productName,
          // onProductNameClick: () => {
          //   dispatch(clearProductState());
          //   navigate('/productDetails', {
          //     state: { isEdit: false, isView: true, _id: product?.productId }
          //   });
          // },
          price:
            product.storeCost || product.storeCost === 0
              ? parseFloat(product.storeCost)?.toFixed(2)
              : parseFloat('0')?.toFixed(2),
          // quantity: 0 ,
          quantity: draftProduct ? draftProduct.quantity : 0,
          categoryName: product?.categoryName,
          subCategoryName: product?.subCategoryName,
          description: product?.description,
          // productChecked: false,
          // productChecked: false || draftProduct && draftProduct.quantity > 0,
          productChecked: draftProduct?.quantity > 0,

          categoryId: product?.categoryId,
          subCategoryId: product?.subCategoryId,
        };
      });

      setOrdersList(filteredData);
      setCount(value?.totalCount);
    }
  }, [value]);

  // function handleCheckQuantityChange(row: any) {
  //   let filteredRowIndex1 = ordersList.findIndex(
  //     (tableRow: any) => tableRow.productId === row?.productId
  //   );
  //   if (filteredRowIndex1 >= 0) {
  //     row.productChecked = row?.quantity > 0;

  //     let a = ordersList;
  //     a[filteredRowIndex1] = row;
  //     setOrdersList([...a]);
  //   }
  // }
  const handleCheckQuantityChange = (row: any, value: any) => {
    const updatedList = [...ordersList];
    const index = updatedList.findIndex(
      (item) => item.productId === row.productId
    );

    if (index !== -1) {
      updatedList[index].quantity = value;
      updatedList[index].productChecked = Number(value) > 0;
      setOrdersList(updatedList);
    }
  };

  const handleRowCheck = (row: any, checked: boolean) => {
    handleCheckQuantityChange(row, value);
  };

  const areOrdersSameAsDraft = (
    draftProducts: any[],
    newOrderProducts: any[]
  ) => {
    if (draftProducts.length !== newOrderProducts.length) return false;

    for (let i = 0; i < draftProducts.length; i++) {
      const draftItem = draftProducts[i];
      const newItem = newOrderProducts.find(
        (item) =>
          item.productId === draftItem.productId &&
          item.quantity === draftItem.quantity
      );

      // if (!newItem || newItem.quantity !== draftItem.quantity) {
      //   return false;
      // }
    }

    return true;
  };

  const handleCreateOrderClick = async () => {
    let selectedRows = ordersList.filter(
      (row: any) => row.productChecked === true
    );

    if (selectedRows.length === 0) {
      dispatch(
        showErrorSnackbar({ message: t('PLEASE_SELECT_AT_LEAST_ONE_PRODUCT') })
      );
      return;
    }

    const draftProducts = _draftOrders?.value?.data?.[0]?.products || [];

    if (areOrdersSameAsDraft(draftProducts, selectedRows)) {
      myContext.setConfirmDialog({
        type: 'createOrder',
        open: true,
        title: t('CONFIRMATION'),
        message: t('THE_ORDER_IN_CART_AND_NEW_ORDER_ARE_SAME'),
        onYesClick: () => {
          // navigate('/createOrder', { state: { selectedOrders: selectedRows } });

          const draftOrderId = _draftOrders?.value?.data?.[0]?._id;
          if (draftOrderId) {
            navigate('/createOrder', {
              state: { draftOrderId, from: 'CartClick' },
            });
          }
        },
        onNoClick: () => {
          // myContext.setConfirmDialog({ open: false });
          navigate('/createOrder', { state: { selectedOrders: selectedRows } });
        },
        onCancelClick: () => {
          myContext.setConfirmDialog({ open: false });
        },
      });
    } else {
      navigate('/createOrder', { state: { selectedOrders: selectedRows } });
    }
  };

  // const handleCreateOrderClick = async () => {
  //   let selectedRows = ordersList.filter((row: any) => row.productChecked === true);
  //   if (selectedRows.length === 0) {
  //     dispatch(showErrorSnackbar({ message: t('PLEASE_SELECT_AT_LEAST_ONE_PRODUCT') }));
  //     return;
  //   }
  //   navigate('/createOrder', { state: { selectedOrders: selectedRows } });
  // };

  function openSaveToCartDialog() {
    let selectedRows = ordersList.filter(
      (row: any) => row.productChecked === true
    );
    if (selectedRows.length > 0) {
      myContext.setConfirmDialog({
        open: true,
        type: 'YES',
        title: t('CONFIRMATION'),
        message: t('ORDER_PRESENT_INCART'),
        onYesClick: async (event: any, param: string | undefined) => {
          let selectedRows = ordersList.filter(
            (row: any) => row.productChecked === true
          );
          if (selectedRows.length > 0) {
            let products = selectedRows
              .filter((item: any) => item?.quantity > 0)
              .map((item: any) => ({
                productId: item?.productId,
                userProductId: item?.userProductId,
                quantity: item?.quantity,
                price: item?.price,
                totalPrice: (
                  Number(item?.quantity) * Number(item?.price)
                ).toFixed(2),
              }));

            if (products?.length > 0) {
              let payload: any = {};

              // if (_draftOrders?.value?.data[0]?._id) {
              //   payload = { products, id: _draftOrders?.value?.data[0]?._id };
              // } else {
              payload = { products };
              // }
              let deletePayload: any = {
                id: _draftOrders?.value?.data[0]?._id,
              };

              await dispatch(deleteDraftOrderById(deletePayload));

              await dispatch(draftorders(payload));
              await dispatch(fetchdraftOrders({ page: 1, limit: 5 }));
              navigate(-1);
            }
          } else {
            dispatch(
              showErrorSnackbar({
                message: t('PLEASE_ADD_QUANTITY_TO_SELECTED_PRODUCTS'),
              })
            );
          }
        },
        onNoClick: () => {
          myContext.setConfirmDialog({ open: false });
        },
      });
    } else {
      dispatch(
        showErrorSnackbar({
          message: t('PLEASE_ADD_QUANTITY_TO_SELECTED_PRODUCTS'),
        })
      );
    }
  }

  // function openSaveToCartDialog() {
  //   myContext.setConfirmDialog({
  //     open: true,
  //     type: 'YES',
  //     title: t('CONFIRMATION'),
  //     message: t('There is an order present in the cart. Do you want to overwrite it'),
  //     onYesClick: async (event: any, param: string | undefined) => {
  //       let selectedRows = ordersList.filter((row: any) => row.productChecked === true);
  //       if (selectedRows.length > 0) {
  //         let products = selectedRows
  //           .filter((item: any) => item?.quantity > 0)
  //           .map((item: any) => ({
  //             productId: item?.productId,
  //             userProductId: item?.userProductId,
  //             quantity: item?.quantity,
  //             price: item?.price,
  //             totalPrice: (Number(item?.quantity) * Number(item?.price)).toFixed(2)
  //           }));

  //         if (products?.length > 0) {
  //           let payload: any = {};
  //           if (_draftOrders?.value?.data[0]?._id) {
  //             payload = { products, id: _draftOrders?.value?.data[0]?._id };
  //           } else {
  //             payload = { products };
  //           }

  //           try {

  //             if (_draftOrders?.value?.data[0]?._id) {
  //               let deletePayload = {
  //                 id: _draftOrders?.value?.data[0]?._id
  //               };
  //               await dispatch(deleteDraftOrderById(deletePayload));
  //             }

  //             await dispatch(draftorders(payload));

  //             await dispatch(fetchdraftOrders({ page: 1, limit: 5 }));

  //             navigate(-1);
  //           } catch (error) {
  //             console.error("Error in processing draft orders: ", error);
  //             dispatch(showErrorSnackbar({ message: t('SOMETHING_WENT_WRONG') }));
  //           }
  //         }
  //       } else {
  //         dispatch(showErrorSnackbar({ message: t('PLEASE_ADD_QUANTITY_TO_SELECTED_PRODUCTS') }));
  //       }
  //     },
  //     onNoClick: () => {
  //       myContext.setConfirmDialog({ open: false });
  //     }
  //   });
  // }

  const handleSaveOrderClick = async () => {
    if (_draftOrders?.value?.data?.length > 0) {
      openSaveToCartDialog();
    } else {
      let selectedRows = ordersList.filter(
        (row: any) => row.productChecked === true
      );
      if (selectedRows.length > 0) {
        let products = selectedRows
          .filter((item: any) => item?.quantity > 0)
          .map((item: any) => ({
            productId: item?.productId,
            userProductId: item?.userProductId,
            quantity: item?.quantity,
            price: item?.price,
            totalPrice: (Number(item?.quantity) * Number(item?.price)).toFixed(
              2
            ),
          }));

        if (products?.length > 0) {
          let payload: any = {};
          if (_draftOrders?.value?.data[0]?._id) {
            payload = { products, id: _draftOrders?.value?.data[0]?._id };
          } else {
            payload = { products };
          }

          await dispatch(draftorders(payload));
          await dispatch(fetchdraftOrders({ page: 1, limit: 5 }));
          navigate(-1);
        } else {
          dispatch(
            showErrorSnackbar({
              message: t('PLEASE_ADD_QUANTITY_TO_SELECTED_PRODUCTS'),
            })
          );
        }
      } else {
        dispatch(
          showErrorSnackbar({
            message: t('PLEASE_SELECT_PRODUCTS_TO_ADD_TO_CART'),
          })
        );
      }
    }
  };

  // const handleSaveOrderClick = async () => {
  //   let selectedRows = ordersList.filter((row: any) => row.productChecked === true);
  //   if (selectedRows.length > 0) {
  //     let products = selectedRows
  //       .filter((item: any) => {
  //         return item?.quantity > 0;
  //       })
  //       .map((item: any) => {
  //         return {
  //           categoryId: item?.categoryId,
  //           subCategoryId: item?.subCategoryId,
  //           //_id: item?._id,
  //           productId: item?.productId,
  //           userProductId: item?.userProductId,
  //           quantity: item?.quantity,
  //           price: item?.price,
  //           totalPrice: (Number(item?.quantity) * Number(item?.price)).toFixed(2)
  //         };
  //       });

  //     if (products?.length > 0) {
  //       if (selectedRows?.length !== products?.length) {
  //         dispatch(showErrorSnackbar({ message: t('PLEASE_ADD_QUANTITY_TO_SELECTED_PRODUCTS') }));
  //       } else {
  //         let payload: any = {};
  //         if (_draftOrders?.value?.data[0]?._id) {
  //           payload = { products, id: _draftOrders?.value?.data[0]?._id };
  //         } else {
  //           payload = { products };
  //         }

  //         // await dispatch(draftorders(payload));
  //         // await dispatch(fetchdraftOrders({ page: 1, limit: 5 }));
  //       }
  //     } else {
  //       dispatch(showErrorSnackbar({ message: t('PLEASE_ADD_QUANTITY_TO_SELECTED_PRODUCTS') }));
  //     }
  //   } else {
  //     dispatch(showErrorSnackbar({ message: t('PLEASE_SELECT_PRODUCTS_TO_ADD_TO_CART') }));
  //   }
  // };

  const handleQuantityChange = (row: any, value: any) => {
    handleCheckQuantityChange(row, value);
  };

  const handleDelete = async (key: any) => {
    // const newFilters = { ...tFilter };
    // delete newFilters[key];
    let newFilters = await deleteKeyFromObject(key, tFilter);
    setTFilter(newFilters);
    refreshPageData(pageNo - 1, search, newFilters);
  };

  function ordersUI() {
    return (
      <Grid>
        <BakeasyPaper>
          <BakeasyHeaderLabel message={t('ORDER_FORM')} />

          <Grid
            container
            spacing={2}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <TextField.Search
                value={search}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setSearch(event?.target?.value);
                  if (
                    event?.target?.value?.length === 0 ||
                    event?.target?.value?.length > 2
                  ) {
                    refreshPageData(
                      pageNo - 1,
                      event?.target?.value?.length === 0
                        ? undefined
                        : event?.target?.value,
                      filter
                    );
                  }
                }}
                onIconClick={(
                  event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                ) => {
                  refreshPageData(pageNo - 1, search, filter);
                }}
                onEnterClick={(
                  event: React.KeyboardEvent<HTMLInputElement>
                ) => {
                  refreshPageData(pageNo - 1, search, filter);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={9} lg={8} xl={8}>
              <div
                className="tableOptions"
                style={{ display: 'flex', justifyContent: 'end' }}
              >
                <Button.SaveToCart
                  // onClick={handleSaveOrderClick}
                  // onClick={function(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
                  //   openSaveToCartDialog();                  }}

                  // disabled={_draftOrders?.value?.data?.length !== 0}
                  onClick={async (
                    event: React.MouseEvent<HTMLButtonElement>
                  ) => {
                    // const cartOrderId = _id;
                    let fg: any = _draftOrders?.value?.data[0]?._id;
                    const draftOrderId: any = fg?._id;

                    if (draftOrderId) {
                      openSaveToCartDialog();
                    } else {
                      handleSaveOrderClick();
                    }
                  }}
                />
                <Button.CreateOrder
                  onClick={handleCreateOrderClick}
                  //disabled={_draftOrders?.value?.data?.length !== 0}
                />
                {/* <Button.Print
                  onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    dispatch(downloadOrderProducts({ ...filter, downloadType: 'pdf' }));
                  }}
                />
                <Button.Export
                  onClick={function(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
                    dispatch(downloadOrderProducts({ ...filter, downloadType: 'csv' }));
                  }}
                /> */}

                <Button.Filter
                  onClick={function (
                    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                  ): void {
                    openFilterStoreproductConfirmDialog();
                  }}
                />
              </div>
            </Grid>
          </Grid>

          {_draftOrders?.value?.data?.length !== 0 && (
            <Grid container sx={{ mt: 2, mb: -1 }}>
              <Typography sx={{ color: RED_500, fontSize: '1.1rem' }}>
                {t('CART_PRESENT_MESSAGE')}
              </Typography>
            </Grid>
          )}

          <BakeasySelectedFilters filter={filter} onDelete={handleDelete} />

          <Grid>
            {ordersList?.length > 0 ? (
              <BakeasyTable
                ref={tableRef}
                pageNo={pageNo - 1}
                search={search}
                headers={orderTableHeaders}
                tableData={ordersList}
                count={count}
                refreshPageData={refreshPageData}
                handleCheckChanged={handleRowCheck}
                handleQuantityChanged={handleQuantityChange}
                filter={filter}
              />
            ) : (
              <BakeasyEmptyMsg message={t('NO_DATA_FOUND')} />
            )}
          </Grid>
        </BakeasyPaper>
      </Grid>
    );
  }

  return ordersUI();
};
